(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('super-loop', {
            parent: 'app',
            url: '/super-loop?isCompany&collectivitySize&city&sector&companyStatus',
            data: {
                pageTitle: 'Axenteev | Super loop',
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/super-loop/super-loop.html',
                    controller: 'SuperLoopController',
                    controllerAs: 'vm'
                }
            },
            params: {
                'collectivitySize': null,
                'city': null,
                'sector': null,
                'companyStatus': null,
                'isCompany': null
            }
        });
    }
})();
